import { QueryClient } from '@tanstack/vue-query'
import { ApiError } from './types'

/**
 * 全局唯一的 QueryClient。
 *
 * 之所以在这里 new 出来、而不是像原先那样交给 `VueQueryPlugin` 的 `queryClientConfig` 内建：
 * **退出登录与换账号登录时必须能把整个查询缓存丢掉**，而 `useQueryClient()` 只能在
 * setup 里调用，会话清理（`stores/session.ts`）是普通函数，拿不到它。
 *
 * 不清缓存会把上一位客户的数据显示给下一位： 现场是「客户还没开通 MT5，
 * 平台下载页却显示了另一位客户的真实/模拟登录号」——缓存键是 `['accounts']`，不带客户身份。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * 只对**网络层失败**（ApiError code -1：超时 / 断网 / 无信封的 5xx）重试一次。
       * 业务码（40312 门禁、42xxx 校验、50311 通道未就绪…）是确定性的，重试只会把同一个错误再演一遍：
       * 多弹一次 toast，或者像 那样把 40312 的「踢回概览」在 1 秒后再触发一次。
       */
      retry: (failureCount, error) =>
        failureCount < 1 && (!(error instanceof ApiError) || error.code === -1),
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
})
